const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWindow2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 726.5 433.72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "95ec4fd5-185b-429b-a4bd-42abcdb03ac7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.9,
    y: 7.66,
    width: 349.5,
    height: 415.8,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 370.07,
    y: 9.59,
    width: 349,
    height: 413,
    style: {
      fill: "#bfd1d0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Livello_3",
    "data-name": "Livello 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M687.49,179.25c1.38-1.86.8-4.64-.73-6.37a13.15,13.15,0,0,0-6-3.35,60.6,60.6,0,0,0-37.64,0A13.61,13.61,0,0,0,620,157.33c.44-13.12-9.67-25.81-22.56-28.32s-27,5.46-31.54,17.79c-1.55,4.24-2.06,8.81-3.8,13s-5.18,8.1-9.68,8.46c-2.89.22-5.67-1.05-8.54-1.39-7.81-.94-16.46,7-14.81,15,4.28,1.23,10.08-.55,14.56-.58,6.85,0,13.7.06,20.56.07q20.55,0,41.12-.23Q646.4,180.68,687.49,179.25Z",
    style: {
      fill: "#e2e8ec"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "661.07 423.59 570.07 424.59 370.07 9.59 389.07 9.59 661.07 423.59",
    style: {
      fill: "#ccdad9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g424"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path426",
    d: "M356.41,423.6H7V7.73H356.41V423.6",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path430",
    d: "M186.89,423.6m0,0H167.07s.13-4,0-4-.36-7.84-.75-8l-23.83-317H148c1.3,0,2.6-.13,3.9-.13s2.61-.13,3.91-.13h1.69c.52,0,2.22.26,3.65.26h.52c1.17,0,2.21-.26,2.34-1,.52-2.22-4.55-5.08-5.47-5.86A56.73,56.73,0,0,0,151.6,83a35,35,0,0,0-10.15-3.52L136.24,9.82H116.32l2.08,70.7c-1.82-5.86-6.38-9.25-10.8-9.25a9.07,9.07,0,0,0-8.08,5.08C96.14,60.72,85.07,49.4,73.74,49.4a9.84,9.84,0,0,0-1.95.13C59.55,51,51,63.85,49,80.91a15.46,15.46,0,0,0-6.77-1.57,17.18,17.18,0,0,0-8.59,2.48c-2.86,1.69-6.77,4.55-8.72,8.2-2.09,3.91.26,3.78,2.86,3.78,4,0,8.2,0,12.24.13l49.09.39c9.89,0,19.79.13,29.68.13l5.47,188.92a17.45,17.45,0,0,0-3.25-1.56,2.92,2.92,0,0,0-1.05-.13c-2.73,0-5.46,2.6-7.81,5.72-2.86-5.59-5.21-10.54-9.76-10.54a9.63,9.63,0,0,0-3.52.78c-5.86,2.6-9.89,10.42-9.37,18a11.4,11.4,0,0,0,3,.13c3.26,0,8.86-.13,14.84-.26s12.24-.13,17.19-.13l3.55,128.24H7.07L7,9.82H356.41V59.29c-1.17.52-2.47,1.3-3.65,2,.26-7.56-5.2-14.59-9.89-16.28a11.21,11.21,0,0,0-3.52-.65c-4.55,0-9.11,2.86-12,7.68,2-3.25-5.07-11.33-6.51-12.37a13.21,13.21,0,0,0-8.2-3.12,15.3,15.3,0,0,0-4,.65,10.77,10.77,0,0,0-6.91,6.77c-1.69,4.56-.52,8.59-.52,13.28h-.26L281.8,9.69H266.05l90.49,261.57V423.87c-7.47-.28-14.47-.28-21.47-.28,1.05-4,5.06-16.4,5.71-21.61h0v-.13h0a6.39,6.39,0,0,0,.14-1.69h0c0-.52.13-1,.13-1.56h0c.13-1.18.13-2.22.26-3.26v-.26h0c0-.78.13-1.69.13-2.47h0v-1.44h0a10.51,10.51,0,0,0-.13-2.08v-.26h0c-.13-2.08-.52-3.51-1.18-3.9s-1.95-.53-4.16-.53c-1.69,0-3.65.13-6,.13a66.26,66.26,0,0,0,9.5-11.06c8.21-11.07,6.38-18.1,3.65-19.92h0a4.38,4.38,0,0,0-2.21-.65c-2.35,0-5.21,1.69-8.08,4.16,2.22-12.89,1.31-25.52-4.55-27.34a7.47,7.47,0,0,0-2.35-.39c-7,0-12.5,9.89-15.23,21.61-2.87-6.64-6.64-11.85-11.33-11.85a6,6,0,0,0-2.86.66c-6.38,2.73-6.77,19.4-1.17,31.63a37.42,37.42,0,0,0,9.89,13.15c-2.47-.13-4.82-.26-6.51-.26a8.83,8.83,0,0,0-3.38.39L260.06,229.07h.13c4.56-.13,9.25-.26,13.8-.26a149.09,149.09,0,0,1,15.37.66h0c.65,0,1.17-.92,1.17-2-.26-5.73-1.43-10-6-12.76a10.55,10.55,0,0,0-4.82-1.17c-2.73,0-5.21.91-5.73,2.6a29.06,29.06,0,0,0-.78-19.4c-2.47-5.72-7-9.5-11.72-9.63h-.26a6.74,6.74,0,0,0-5.6,2.73c-1.82,2.48-2.47,6.12-2.47,9.77L210.06,9.3H180.64l42.83,211.44a11.08,11.08,0,0,0-2.08,2.22c-2.47,3.51-2.73,5.85,1.43,6.38a14.25,14.25,0,0,0,2.35.13l39.9,194.12ZM356.41,195.09,306.67,71.53c5.34.13,10.68.26,16.15.26h5.08c2.08,0,16-.52,28.51-.65v124",
    style: {
      fill: "#bfd1d0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g432"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#95ec4fd5-185b-429b-a4bd-42abcdb03ac7)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path442",
    d: "M92.47,295.63a12.84,12.84,0,0,1-3-.11c-.6-7.54,3.59-15.42,9.33-17.93a8.08,8.08,0,0,1,3.46-.84c4.54,0,6.93,4.9,9.68,10.52,2.39-3.23,5-5.74,7.89-5.74a3.32,3.32,0,0,1,1.08.12,13,13,0,0,1,3.23,1.55l.35,12.08c-5,0-11.35.12-17.21.24s-11.59.11-14.82.11",
    style: {
      fill: "#e2e8ec"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path446",
    d: "M322.69,71.79c-5.34,0-10.68-.13-16.15-.26l-5.73-14.32h.26c0-4.69-1.17-8.72.53-13.28a11.43,11.43,0,0,1,10.93-7.42,13.26,13.26,0,0,1,8.21,3.12c1.43,1,8.46,9.12,6.51,12.37,2.86-4.82,7.42-7.68,12-7.68a11.15,11.15,0,0,1,3.52.65c4.69,1.69,10.28,8.72,9.89,16.28a19.47,19.47,0,0,1,3.65-2V71.14c-12.5.13-26.43.65-28.51.65h-5.08",
    style: {
      fill: "#e2e8ec"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path450",
    d: "M161.26,94.6a20.27,20.27,0,0,1-3.76-.36h-1.58c-1.34,0-2.55.12-3.89.12s-2.54.12-4,.12h-5.34l-1.09-15A31.93,31.93,0,0,1,151.79,83a48.11,48.11,0,0,1,6.92,4.61c1,.73,6.07,3.64,5.58,6-.12.73-1.21,1-2.42,1.09h-.61m-42.48-.24C109,94.24,99,94.11,89,94.11l-49.16-.36c-4.12,0-8.13-.12-12.26-.12-2.55,0-4.85.12-2.79-3.76,1.94-3.64,5.83-6.56,8.74-8.26a17.56,17.56,0,0,1,8.62-2.42,14.58,14.58,0,0,1,6.67,1.57c2.07-17,10.69-30,22.82-31.31a10.64,10.64,0,0,1,1.95-.12c11.28,0,22.33,11.28,25.73,26.94,2.06-3.52,5.09-5.1,8.13-5.1,4.49,0,9.1,3.4,10.8,9.23l.49,14",
    style: {
      fill: "#e2e8ec"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path454",
    d: "M289.48,230h0c-5.21-.51-10.3-.64-15.51-.64-4.58,0-9.29.13-13.86.26H260l-6.61-29.38c0-3.56.5-7.25,2.41-9.66a6.83,6.83,0,0,1,5.72-2.68h.26c4.7.13,9.16,3.95,11.7,9.67a29.54,29.54,0,0,1,.76,19.33c.51-1.65,3-2.54,5.73-2.54a10.45,10.45,0,0,1,4.83,1.14c4.45,2.67,5.72,7,6,12.72-.13.76-.64,1.78-1.28,1.78m-64.09,0a14.72,14.72,0,0,1-2.29-.25c-4.2-.39-3.95-2.93-1.53-6.36a10.82,10.82,0,0,1,2-2.16l1.78,8.77",
    style: {
      fill: "#e2e8ec"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path458",
    d: "M356.41,271.39,265.92,9.82h15.76l19.13,47.52c-2.6.13-4.94-.39-7.42,2.08s-4,7.29-3.64,11.85l16.79.39L451.07,424.59l-54-3",
    style: {
      fill: "#ccdad9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path462",
    d: "M306.57,71.62l-16.76-.38c-.38-4.48,1.15-9.21,3.71-11.77s4.73-1.92,7.42-2l5.63,14.19",
    style: {
      fill: "#e8edf0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path466",
    d: "M307.07,424.59c-12-.51-31.55-.49-42-1L225.46,229.91c1.91.12,3.69.12,5.48.12,3.05,0,6.11-.12,9-.25,1.79,0,3.57-.13,5.23-.13h1.15c4.46,0,9-.12,13.63-.25L295.29,385a.12.12,0,0,0-.12.13h0c0,.13-.13.26-.13.38h0a4.59,4.59,0,0,0-.26,1.4h0c0,.39-.12.64-.12,1.15h0a92.07,92.07,0,0,0-.13,10.71v.12h0c0,.9.13,1.66.13,2.55h0v.26A77.3,77.3,0,0,0,296.44,415M223.67,221.24,180.85,9.69h29.44l43.2,190.4a44.58,44.58,0,0,0,.51,6,25.36,25.36,0,0,0-2.29-3.32,5.68,5.68,0,0,0-4-2.16,2.6,2.6,0,0,0-.89.12c-5.1,1.41-4.21,8.67-2.94,14.15a9.62,9.62,0,0,0-2.8-1.66,5.73,5.73,0,0,0-1.4-.25,4.39,4.39,0,0,0-2.68,1,9.12,9.12,0,0,0-2.67,6.75,8.91,8.91,0,0,0-4.72-1.4,10.19,10.19,0,0,0-6,1.91",
    style: {
      fill: "#ccdad9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path470",
    d: "M231,230.11c-1.88,0-3.65,0-5.53-.12l-1.76-8.68a9.62,9.62,0,0,1,5.78-1.89,8.45,8.45,0,0,1,4.66,1.38,9.18,9.18,0,0,1,2.76-6.79,4.66,4.66,0,0,1,2.77-1,5.15,5.15,0,0,1,1.38.25,9.14,9.14,0,0,1,2.9,1.76c-1.39-5.41-2.14-12.7,2.89-14.09a2.23,2.23,0,0,1,.88-.12,5.37,5.37,0,0,1,3.9,2.14,24.94,24.94,0,0,1,2.26,3.27,47.31,47.31,0,0,1-.5-6L260,229.61c-4.52.12-9,.25-13.58.25h-1.13c-1.76,0-3.52,0-5.28.13-3,0-6,.12-9.06.12",
    style: {
      fill: "#e8edf0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path474",
    d: "M128.07,423.59l-3.54-128.24h.36c5.35,0,9.11.12,9.11.48h0c-.12-5.1-5.71-10.08-9.71-12.51L118.82,94.45c3.16,0,6.32.12,9.47.12,4.86,0,9.6.12,14.46.12l25.32,328.9c-6.15,0-6.94,0-8,0h-32m-9.37-342c-.12-.36-.12-.73-.24-1.09L116.39,9.79h19.92l5.22,69.72-2.43-.37c-.48,0-1.82-.12-3.76-.12-6.07,0-17.13.49-16.64,2.55",
    style: {
      fill: "#ccdad9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path478",
    d: "M133.91,295.74c0-.36-3.72-.48-9.11-.48h-.36l-.36-12.11c4.2,2.52,9.71,7.43,9.83,12.59",
    style: {
      fill: "#e8edf0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path482",
    d: "M142.6,94.51c-4.82,0-9.63-.12-14.45-.12-3.13,0-6.26,0-9.51-.13l-.36-13.84a3.56,3.56,0,0,1,.24,1.09C118,79.46,129.12,79,135.25,79a25.81,25.81,0,0,1,3.74.12c.84.12,1.68.24,2.4.36l1.21,15.05",
    style: {
      fill: "#e8edf0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path486",
    d: "M183.92,425.88H179.4V7.74h4.52V425.88",
    style: {
      fill: "#d9a476"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path490",
    d: "M357.55,290.4V297H2.49V290.4H357.55",
    style: {
      fill: "#d9a476"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path494",
    d: "M363.37,0V9.79H0V0H363.37",
    style: {
      fill: "#d9a476"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path498",
    d: "M357.55,140.87v6.64H2.49v-6.64H357.55",
    style: {
      fill: "#d9a476"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path422",
    d: "M719.45,0V422.63H370.05V0h-6.92V433.72H726.5V0h-7",
    style: {
      fill: "#d9a476"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g484-2",
    "data-name": "g484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path486-2",
    "data-name": "path486",
    d: "M546.92,425.88H542.4V7.74h4.52V425.88",
    style: {
      fill: "#d9a476"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g488-2",
    "data-name": "g488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path490-2",
    "data-name": "path490",
    d: "M720.55,290.4V297H365.49V290.4H720.55",
    style: {
      fill: "#d9a476"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g492-2",
    "data-name": "g492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path494-2",
    "data-name": "path494",
    d: "M726.37,0V9.79H363V0H726.37",
    style: {
      fill: "#d9a476"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g496-2",
    "data-name": "g496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path498-2",
    "data-name": "path498",
    d: "M720.55,140.87v6.64H365.49v-6.64H720.55",
    style: {
      fill: "#d9a476"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path502",
    d: "M343.1,354.05c2.73,1.82,4.55,8.83-3.63,20-6.36,8.7-14.15,17.52-21.81,15.57-3.5-.9,4.42-17.65,7.66-23,5.06-8.31,13.5-15.58,17.78-12.59",
    style: {
      fill: "#9aa640"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path506",
    d: "M343.18,354a2.7,2.7,0,0,1-.13,1.43c-.13.38-.39.9-.52,1.29-.39.91-.78,1.69-1.17,2.46-.9,1.69-1.81,3.24-2.72,4.93-1.94,3.24-3.89,6.35-6,9.46s-4.28,6.09-6.48,9.07c-1.17,1.43-2.2,3-3.5,4.41-.65.65-1.17,1.42-1.94,2.07a6.51,6.51,0,0,1-1,.91,2.84,2.84,0,0,1-.65.39c-.13,0-.26.13-.39.13a.28.28,0,0,1-.26-.26,8.38,8.38,0,0,1,.52-2.72c.26-.91.65-1.82.91-2.6.78-1.68,1.55-3.37,2.46-5.05a90.37,90.37,0,0,1,5.7-9.59,76.22,76.22,0,0,1,6.74-8.81,29.17,29.17,0,0,1,8.43-7.52m0,0a37.45,37.45,0,0,0-8.3,7.39,107.77,107.77,0,0,0-6.74,8.81c-2.07,3.11-4,6.22-5.83,9.59A45.45,45.45,0,0,0,320,384.8c-.26.91-.65,1.69-.91,2.6a10,10,0,0,0-.52,2.72c0,.26.26.13.52.13s.39-.26.52-.39c.39-.26.65-.65,1-.91a25.76,25.76,0,0,0,1.81-2.07c1.17-1.43,2.33-2.85,3.37-4.41,2.2-3,4.41-6,6.48-9.07s4.15-6.22,6.09-9.33c.91-1.56,1.95-3.24,2.85-4.8.39-.77.91-1.68,1.3-2.46a8.15,8.15,0,0,0,.65-2.85",
    style: {
      fill: "#6c8521"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path510",
    d: "M316,389.66c-14.86-6.72-5.55-64.87,12.41-59.44,6.07,1.81,6.72,15.5,4.26,28.81-3.23,16.54-10.85,33.21-16.67,30.63",
    style: {
      fill: "#6c8521"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path514",
    d: "M334.32,313.78c0-.12-.26-.25-.39-.25-3.36.64-9,16.41-5.42,16.67,3.87.13,7.36-10.08,5.81-16.42",
    style: {
      fill: "#e04d46"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path518",
    d: "M333.92,313.8a55.12,55.12,0,0,0-1.81,6.33,62.19,62.19,0,0,1-1.81,6.45c.39-2.19,1-4.26,1.42-6.45a40.34,40.34,0,0,1,2.2-6.33",
    style: {
      fill: "#f3574a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path522",
    d: "M329.49,314.87c.13,0,.26.26.26.39-.52,2.58,1.29,15.48-1.55,15s-3.36-16.39,1.29-15.36",
    style: {
      fill: "#f3574a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path526",
    d: "M329.41,315.17a11.77,11.77,0,0,0-1.94,7.23c0,2.57.65,5,.91,7.6l-.78-3.74a19.18,19.18,0,0,1-.39-3.74,19.52,19.52,0,0,1,.39-3.86,7.52,7.52,0,0,1,1.81-3.49",
    style: {
      fill: "#e04d46"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path530",
    d: "M336.76,320.1a.4.4,0,0,1,.52,0c1.55,1.94-1.56,10.09-7.64,10.48-5.82.26,5.7-8.41,7.12-10.48",
    style: {
      fill: "#f3574a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g532"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path534",
    d: "M337.06,320.65a10.27,10.27,0,0,1-2.71,5.56,14.25,14.25,0,0,1-5.18,3.49,17.36,17.36,0,0,0,5.05-3.62,16.68,16.68,0,0,0,2.84-5.43",
    style: {
      fill: "#e04d46"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path538",
    d: "M323.24,317.14c-5.42,4.64,1.29,13.15,5,13,.39-3.22-4.25-13.66-5-13",
    style: {
      fill: "#e04d46"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path542",
    d: "M323.31,317.65a9,9,0,0,0,.26,3.22,27.84,27.84,0,0,0,.9,3.1,20.34,20.34,0,0,0,1.29,3,9.73,9.73,0,0,0,1.93,2.58,13.24,13.24,0,0,1-3.48-5.54,13.49,13.49,0,0,1-.77-3.23,6.09,6.09,0,0,1-.13-3.09",
    style: {
      fill: "#f3574a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path546",
    d: "M327.92,329.89c-.52.91,9.33,4.66,13.6-4.27-5.18-2.21-13.6,4.27-13.6,4.27",
    style: {
      fill: "#e04d46"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g548"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path550",
    d: "M340.73,325.77c-.9.52-1.81,1.3-2.72,2a13.33,13.33,0,0,1-3,1.55,14.16,14.16,0,0,1-3.37.78,14.6,14.6,0,0,1-3.37,0,14.74,14.74,0,0,0,3.37-.26,13.12,13.12,0,0,0,3.24-.78,13.62,13.62,0,0,0,3-1.55c.9-.52,1.81-1.17,2.84-1.69",
    style: {
      fill: "#f3574a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g552"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path554",
    d: "M328.05,330.21c-.9.9-1.16,2.19-1.68,3.35s-.77,2.45-1,3.61c-.64,2.45-1.16,4.9-1.8,7.48-1,5-1.94,9.92-2.84,15s-1.68,10-2.45,15.08c-.38,2.58-.64,5-.9,7.6-.13,1.29-.26,2.58-.39,3.74,0,.65-.13,1.29-.13,1.94v.9a1.21,1.21,0,0,0,.26.9,1.21,1.21,0,0,1-.26-.9V386c.13-1.29.13-2.58.26-3.86.26-2.58.52-5,.9-7.61q1-7.55,2.32-15.08c.91-5,1.81-10.05,3-15,.51-2.45,1.16-5,1.8-7.48.39-1.29.78-2.45,1.16-3.61a11.59,11.59,0,0,1,1.81-3.22",
    style: {
      fill: "#9aa640"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g556"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path558",
    d: "M328.05,330.13a73.11,73.11,0,0,1-.91,30.56,137.07,137.07,0,0,1-4.38,14.7c-1.68,4.9-3.61,9.67-5.42,14.44,1.81-4.77,3.61-9.67,5.29-14.44a127.12,127.12,0,0,0,4.26-14.7,86.84,86.84,0,0,0,2.19-15.22,101.64,101.64,0,0,0-1-15.34",
    style: {
      fill: "#9aa640"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path562",
    d: "M327.56,330.15a20.75,20.75,0,0,0-4.89,6.19,52.63,52.63,0,0,0-3.23,7.21,93.09,93.09,0,0,0-4,15.34A91.72,91.72,0,0,0,314,374.61a40,40,0,0,0,.65,7.86,26.76,26.76,0,0,0,2.19,7.61,25.27,25.27,0,0,1-2.45-7.48,53.31,53.31,0,0,1-.65-7.86,82.3,82.3,0,0,1,1.29-15.85,85.65,85.65,0,0,1,4-15.33,51.77,51.77,0,0,1,3.35-7.22,24.15,24.15,0,0,1,5.15-6.19",
    style: {
      fill: "#9aa640"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path566",
    d: "M318.43,389.25c1.93-.39.52-10.15-2.95-23.39-3.35-13-9.52-29.57-18.9-25.58-6.3,2.7-6.81,19.41-1.16,31.62,5.27,11.69,14.91,18.89,23,17.35",
    style: {
      fill: "#9aa640"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path570",
    d: "M317.19,389.68a26.18,26.18,0,0,1-10.91-8.86,47.21,47.21,0,0,1-6.42-12.71,72.57,72.57,0,0,1-3.21-13.87c-.26-2.31-.52-4.75-.64-7.06a32.81,32.81,0,0,1,.38-7.06,43.88,43.88,0,0,0-.26,7.06c.13,2.31.39,4.75.65,7.06A71.28,71.28,0,0,0,300,368a44.29,44.29,0,0,0,6.29,12.58,27.67,27.67,0,0,0,10.91,9.12",
    style: {
      fill: "#6c8521"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path574",
    d: "M296.48,340.2c2.18,4,3.6,8.47,5.14,12.71l4.49,13c1.54,4.37,3.08,8.61,4.88,12.84a68.67,68.67,0,0,0,3,6.3,15.52,15.52,0,0,0,4,5.52,17.64,17.64,0,0,1-4.11-5.52,66.62,66.62,0,0,1-3-6.17c-1.79-4.24-3.46-8.47-5-12.84l-4.49-13c-.77-2.18-1.54-4.37-2.31-6.42a30.43,30.43,0,0,0-2.57-6.42",
    style: {
      fill: "#6c8521"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path578",
    d: "M296.48,340.2c3.72,2.82,6.42,6.8,8.73,10.91a95.17,95.17,0,0,1,5.91,12.72,117.12,117.12,0,0,1,4,13.48c.64,2.31,1,4.63,1.54,6.81s.77,4.62,1.16,6.93c-.9-4.62-1.67-9.24-3-13.74A121.61,121.61,0,0,0,310.73,364,75.57,75.57,0,0,0,305,351.24c-1.16-2.05-2.44-4-3.73-5.91a22.52,22.52,0,0,0-4.75-5.13",
    style: {
      fill: "#6c8521"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path582",
    d: "M290.75,323.81c0-.13.25-.26.38-.26,3.45.64,9.06,16.46,5.36,16.72s-7.27-10.21-5.74-16.46",
    style: {
      fill: "#e04d46"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path586",
    d: "M291.18,323.86a27.62,27.62,0,0,1,2,6.24c.51,2.17,1,4.33,1.4,6.5-.64-2-1.27-4.2-1.78-6.37a37.27,37.27,0,0,0-1.66-6.37",
    style: {
      fill: "#f3574a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g588"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path590",
    d: "M295.58,324.84c-.13,0-.26.25-.26.38.51,2.68-1.4,15.44,1.53,14.93s3.45-16.33-1.27-15.31",
    style: {
      fill: "#f3574a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g592"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path594",
    d: "M295.7,325.17a8.39,8.39,0,0,1,1.79,3.32,13.06,13.06,0,0,1,.38,3.82,38.19,38.19,0,0,1-.38,3.83l-.77,3.7c.26-2.55.77-5,.89-7.53a11.55,11.55,0,0,0-1.91-7.14",
    style: {
      fill: "#e04d46"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path598",
    d: "M288.34,330.21c-.13-.13-.38-.26-.51,0-1.53,2,1.53,10.08,7.66,10.46,5.87.26-5.74-8.55-7.15-10.46",
    style: {
      fill: "#f3574a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path602",
    d: "M288,330.66a13.65,13.65,0,0,0,2.93,5.35,18,18,0,0,0,5,3.69,12,12,0,0,1-5.23-3.44,12.73,12.73,0,0,1-2.67-5.6",
    style: {
      fill: "#e04d46"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path606",
    d: "M295.19,385.23c-2.08,2.2-1.3,33.95,5.31,38s31.37,3.76,35.12,0,7.91-35.64,4.54-38c-1.68-1.17-12.31,0-22.94.13-3.63,0-7.26-.13-10.5-.26-6.09-.26-10.76-.52-11.53.13",
    style: {
      fill: "#5e8c89"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g608"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path610",
    d: "M340.7,402.16h0",
    style: {
      fill: "#7d8887"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path614",
    d: "M294.53,402.17v-.26h0v.26",
    style: {
      fill: "#838c8b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path618",
    d: "M340.7,402h0",
    style: {
      fill: "#7d8887"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path622",
    d: "M318.06,404c-7.76,0-15.13-.39-20.82-.78a2.46,2.46,0,0,1,.13-1c5.56.38,13.06.77,20.69.77a176.71,176.71,0,0,0,18.74-.9c-.13.38-.25.77-.38,1.16-5.69.52-12.16.78-18.36.78m-23.54-1.3V402h0v.77",
    style: {
      fill: "#4c6563"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path626",
    d: "M294.48,388.55h0a3.76,3.76,0,0,1,.12-1.15h0c0,.38-.12.77-.12,1.15",
    style: {
      fill: "#838c8b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path630",
    d: "M318.85,389.67c-6,0-11.78-.26-16.69-.51a29.15,29.15,0,0,1,3.88-.91c4,.13,8.41.26,12.81.26a149.92,149.92,0,0,0,20.58-1.17c0,.39-.13.78-.13,1.17a170,170,0,0,1-20.45,1.16m-24.33-1.16h0c0-.39.13-.78.13-1h0a2.53,2.53,0,0,0-.13,1",
    style: {
      fill: "#4c6563"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path634",
    d: "M341.23,395.65v-.26h0v.26",
    style: {
      fill: "#7d8887"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g636"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path638",
    d: "M300.16,400.7h-.25a6.71,6.71,0,0,1-2.2-1.42c.13-.39.13-.91.25-1.3a8.23,8.23,0,0,0,2.2,1.69h0c.78,0,2.46-2.46,3.5-3.89,1.81-2.45,3-4,4-4h0c1,0,2.07,1.43,3.75,3.63,1.3,1.81,2.85,4,3.88,4h0c1.17,0,2.72-2.33,3.88-4.14,1.43-2.07,2.33-3.37,3.24-3.37h0c.91,0,1.94,1.17,3.49,3.24,1.17,1.68,3,4,4,4h0c1,0,2.46-2.33,3.5-4,1.16-1.94,2.2-3.5,3.23-3.5h.13c.52,0,1.17.52,2.07,1.17-.13.39-.13.9-.26,1.29-.77-.78-1.55-1.42-1.94-1.42s-1.55,1.81-2.2,3c-1.42,2.2-2.84,4.53-4.53,4.53h0c-1.55,0-3.23-2.33-4.78-4.4-.78-1.16-2.07-2.84-2.59-2.84s-1.55,1.68-2.33,2.84c-1.55,2.2-3.11,4.53-4.79,4.53h0c-1.68,0-3.23-2.33-4.78-4.53-.91-1.29-2.2-3.23-2.85-3.23h0c-.65,0-2.2,2.2-3.24,3.62-1.68,2.46-3.1,4.53-4.4,4.53",
    style: {
      fill: "#4c6563"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g640"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path642",
    d: "M300.39,395.5h-.26a3.7,3.7,0,0,1-1.53-.51c.13-.39.26-.77.38-1a3.31,3.31,0,0,0,1.28.52h.13a2.09,2.09,0,0,0,1.28-.64,4.74,4.74,0,0,0,1.4-2.18,10.45,10.45,0,0,0-2.94-.51,8.71,8.71,0,0,1,.64-1,13.94,13.94,0,0,1,1.79.26c.77.12,1.66.38,1.66,1.15a5.08,5.08,0,0,1-1.79,3.19,3.4,3.4,0,0,1-2,.77",
    style: {
      fill: "#4c6563"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g644"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path646",
    d: "M315.64,396.87a4.38,4.38,0,0,1-2.44-1.41c-1-1-2.44-3.09-2.05-4.12.12-.25.25-.38.51-.38a55.26,55.26,0,0,1,5.65-.39,3.8,3.8,0,0,1,1.93.26,1.11,1.11,0,0,1,.52,1.16c-.13,1.54-2.32,4.62-3.73,5l-.39-.13m1.8-5.27a40.07,40.07,0,0,0-5.14.39,7.27,7.27,0,0,0,1.8,2.69,3.44,3.44,0,0,0,1.54,1h0a6.91,6.91,0,0,0,2.19-2.44,3.91,3.91,0,0,0,.64-1.67c-.13.13-.51,0-1,0",
    style: {
      fill: "#4c6563"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g648"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path650",
    d: "M329.77,396.47A2.7,2.7,0,0,1,328,395.3c-.9-1.16-2.19-3.36-1.93-4.26.13-.26.26-.39.51-.39h2.2c1.68,0,4,0,4.78-.13h.13a.76.76,0,0,1,.65.26,1.24,1.24,0,0,1,0,1.16c-.39,1.3-3.11,4.4-4.53,4.53h0m-2.45-4.65a10.12,10.12,0,0,0,1.68,3,3.61,3.61,0,0,0,.77.64h0c.65-.13,3-2.58,3.49-3.74-1.16.13-3,.13-4.52.13h-1.42",
    style: {
      fill: "#4c6563"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g652"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path654",
    d: "M323.65,402a16.09,16.09,0,0,1-4.76-.64,1.19,1.19,0,0,1-.39-1.16c.26-1.55,2.45-3.61,3.35-4a.48.48,0,0,1,.39-.13,1.16,1.16,0,0,1,.64.13,10.43,10.43,0,0,1,3.61,4.64.73.73,0,0,1-.52.9,8.68,8.68,0,0,1-2.32.26m-1.41-4.89c-.78.38-2.58,2.19-2.71,3.22v.25a16.79,16.79,0,0,0,4.25.39,4.84,4.84,0,0,0,1.55-.13c-.39-1.16-2.45-3.73-3.09-3.73",
    style: {
      fill: "#4c6563"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g656"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path658",
    d: "M340.84,400.4a6.29,6.29,0,0,0,.13-1.55h0a6.29,6.29,0,0,1-.13,1.55h0",
    style: {
      fill: "#7d8887"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path662",
    d: "M334.41,401.39h-.26a.71.71,0,0,1-.65-.39c-.26-.65.39-1.81,1-2.72s1.81-2.33,3-2.33h.13l.26.13c.13.13.26.26.39.26-.13.39-.13.78-.26,1.17a2.84,2.84,0,0,0-.65-.52c-.13,0-.39.13-.77.52a11.51,11.51,0,0,0-1.94,2.71,26.5,26.5,0,0,0,2.71-.26l-.39,1.17c-1,.13-2.07.26-2.58.26",
    style: {
      fill: "#4c6563"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path666",
    d: "M307.85,401.47h-1.28c-2.3-.13-3.58-.51-3.84-1.15a1,1,0,0,1,0-.9c.64-1.28,3.84-3.07,4.36-3.33h.25c.9,0,2.18,1.41,2.56,1.92.9,1.15,1.29,2.05.9,2.69-.13.64-1.66.77-2.95.77m-.38-4.23a12.79,12.79,0,0,0-3.72,2.57c.52.38,2.57.51,4.1.51a6.45,6.45,0,0,0,2-.26,7.23,7.23,0,0,0-2.43-2.82",
    style: {
      fill: "#4c6563"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g668"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path670",
    d: "M294.38,399.34h0",
    style: {
      fill: "#838c8b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path674",
    d: "M294.52,401v-.51c-.13.13,0,.38,0,.51m-.13-1.66h0v0",
    style: {
      fill: "#4c6563"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path678",
    d: "M341.37,392.94h0v-1.43h0v1.43m-.13-3.5v-.26h0v.26",
    style: {
      fill: "#7d8887"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path682",
    d: "M339,391.06h0a.81.81,0,0,1-.13-.9c0-.13.13-.26.26-.39a4.81,4.81,0,0,1-.13,1.29",
    style: {
      fill: "#4c6563"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g684"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path686",
    d: "M338.13,417c-3.11-.13-6.22-.39-9.19-.52.25-.13.38-.39.51-.52,3.11-3.24,5.44-8,7-12.95,1.42-.13,2.85-.39,4.14-.52v-.26A106.07,106.07,0,0,1,338.13,417m2.59-14.9h0m0-.13a1,1,0,0,1,.13-.64,37.43,37.43,0,0,1-4,.52c.13-.26.13-.52.25-.78.39,0,.65-.13.91-.13a11.62,11.62,0,0,0,3-.65c-.13.65-.13,1.17-.26,1.68m-3.37-1.94c.26-.9.39-1.68.65-2.59a18.7,18.7,0,0,1,2.2,2.07,23.34,23.34,0,0,1-2.85.52M341,398.9a15.3,15.3,0,0,0-2.85-2.59l.39-1.95,1.16,1.17a13.08,13.08,0,0,0,1.43,1.29,3.57,3.57,0,0,1,.13-1.16,29.54,29.54,0,0,1-.26,3.24m.26-3.63-.65-.65c-.65-.64-1.29-1.16-1.81-1.68A10,10,0,0,0,339,391a25.49,25.49,0,0,0,2.33,1.94,14,14,0,0,1-.13,2.33m.13-3.76c-.52-.38-.91-.77-1.17-.9a8.29,8.29,0,0,1,1.17-.26v1.16m-2.2-1.68c0-.52.13-.91.13-1.29.64-.13,1.16-.13,1.68-.26,0-.39-.13-.78-.13-1-.52.13-1,.13-1.42.26,0-.78.13-1.42.13-2.07h.51c.65.39,1,1.81,1.17,4a3.54,3.54,0,0,0-2.07.39",
    style: {
      fill: "#527f7c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g688"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path690",
    d: "M336.44,403.08l.39-1.16c1.42-.13,2.71-.39,4-.52a1,1,0,0,1-.13.65h0v.13h0v.26c-1.42.25-2.85.51-4.27.64",
    style: {
      fill: "#425c5a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g692"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path694",
    d: "M339.39,388.5c0-.39.13-.78.13-1.17.52-.13,1-.13,1.43-.26a2.86,2.86,0,0,1,.13,1,7.94,7.94,0,0,1-1.69.39",
    style: {
      fill: "#425c5a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g696"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path698",
    d: "M341.23,396.81c-.52-.39-.91-.91-1.43-1.29l-1.16-1.17c.13-.39.13-.91.26-1.29.51.38,1,1,1.81,1.68.26.26.52.39.65.65v.26a3.51,3.51,0,0,0-.13,1.16",
    style: {
      fill: "#425c5a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g700"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path702",
    d: "M337.08,401.18a3.8,3.8,0,0,0,.26-1.17c1.17-.13,2.2-.39,2.85-.52a18.7,18.7,0,0,0-2.2-2.07c.13-.39.13-.77.26-1.16a21.86,21.86,0,0,1,2.85,2.59c0,.51-.13,1-.13,1.55a11.62,11.62,0,0,1-3,.65c-.39,0-.65.13-.91.13",
    style: {
      fill: "#425c5a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g704"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path706",
    d: "M341.37,392.94A25.49,25.49,0,0,1,339,391c0-.39.13-.78.13-1.17a7.35,7.35,0,0,1,2.07-.65v1.17a8.29,8.29,0,0,0-1.17.26,11.24,11.24,0,0,0,1.17.9V392a2.21,2.21,0,0,1,.13.91",
    style: {
      fill: "#425c5a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path710",
    d: "M294.91,386.1h0m0-.13h0m0,0h0m.12-.38h0m0,0h0m0,0h0m0-.13h0m0,0h0m0,0h0m0,0h0m0,0h0m.13,0h0m0,0h0m0-.12h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m.13-.13h0",
    style: {
      fill: "#d1dedd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path714",
    d: "M297.77,415h-1.3a86.76,86.76,0,0,1-1.81-12.16v.26c.78.12,1.68.12,2.59.25a45,45,0,0,0,.52,11.65m-.52-12.94c-1-.13-1.94-.13-2.72-.26a2.21,2.21,0,0,0-.13-.91h0c1.56-.13,1.69-.51,1.69-.64.25-.65-.39-1.3-1.95-2.46v1a85.68,85.68,0,0,1,.13-10.35c2.2.13,4.79.39,7.64.51a6.34,6.34,0,0,0-.91.39c-.25.13-.38.39-.64.65-.65,0-1.3-.13-1.94-.13-1.56,0-3,.13-3.24.78a1.8,1.8,0,0,0,.26,1.55,7.94,7.94,0,0,0,2.85,2.59,17,17,0,0,0-.65,3A50.42,50.42,0,0,1,294,394v1.69a27,27,0,0,0,3.5,3.36,23.05,23.05,0,0,1-.26,3m-2.85-1.55a3.6,3.6,0,0,0-.13-1.17c.26.26.52.39.65.52h-.52v.65m4.53-6.61a6.79,6.79,0,0,1-2.2-2.07,1,1,0,0,1-.13-.51,8.83,8.83,0,0,1,2.33-.26h1.3a8,8,0,0,0-1.3,2.84m7.12-5.69c-4.53-.26-8.41-.52-11.52-.78.13-.52.13-1,.26-1.42h0c0-.13.13-.26.13-.39h0c.39-.39,1.55-.52,3.5-.52s4.79.13,7.89.26,6.73.26,10.23.26h.26c7.25,0,14.37-.52,18.77-.52,2.07,0,3.62.13,4.14.52-.13-.13-.26-.13-.52-.26v.26c-9.45.13-25.11,1.16-33.14,2.59",
    style: {
      fill: "#6e9895"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g716"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path718",
    d: "M297.26,403.24c-.89-.13-1.79-.13-2.55-.26v-.25a2.41,2.41,0,0,0-.13-.89c.89.12,1.79.12,2.81.25a3.48,3.48,0,0,0-.13,1.15",
    style: {
      fill: "#5e7573"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g720"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path722",
    d: "M302.19,389.14c-2.94-.13-5.5-.38-7.67-.51,0-.39.13-.77.13-1.15,3.07.25,7,.51,11.51.76a17.24,17.24,0,0,0-4,.9",
    style: {
      fill: "#5e7573"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path726",
    d: "M297.71,399.25a44.28,44.28,0,0,1-3.45-3.44v-1.66c1.15,1.28,2.55,2.68,3.7,3.83a3.67,3.67,0,0,0-.25,1.27",
    style: {
      fill: "#5e7573"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g728"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path730",
    d: "M298.64,395.09a8.27,8.27,0,0,1-2.93-2.56,1.75,1.75,0,0,1-.26-1.53c.26-.64,1.79-.89,3.32-.89a8.83,8.83,0,0,1,1.91.13,6.49,6.49,0,0,0-.63,1h-1.28a9.12,9.12,0,0,0-2.3.25.94.94,0,0,0,.13.51,7.31,7.31,0,0,0,2.3,2.05,2.32,2.32,0,0,0-.26,1",
    style: {
      fill: "#5e7573"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path734",
    d: "M294.44,401.06h0v-1.14H295a2.7,2.7,0,0,0-.64-.51v-1.53c1.53,1.27,2.17,1.91,1.91,2.55-.13.12-.25.51-1.78.63",
    style: {
      fill: "#5e7573"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path738",
    d: "M339.56,385.38v-.26a.68.68,0,0,1,.52.26h-.52",
    style: {
      fill: "#648c89"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g420-2",
    "data-name": "g420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path422-2",
    "data-name": "path422",
    d: "M356.45,0V422.63H7.05V0H.13V433.72H363.5V0h-7.05",
    style: {
      fill: "#d9a476"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWindow2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/window2.fcada003cdf6ea2f913adca79328e181.svg";